import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import Script from 'react-load-script'
import { compose, gql, graphql } from 'react-apollo'
import { Form, Button, Row, Col, message } from 'antd'
import { injectIntl, FormattedMessage } from 'react-intl'
import _get from 'lodash/get'
// import config from '~/config'
// import queryString from 'query-string'
import moment from 'moment'

import RegistrationSteps from '~/App/components/RegistrationSteps'
import OmiseModal from '../../../components/OmiseModal'
import TransferModal from '../../../components/TransferModal'
import registrationQuery from '~/App/graphql/queries/registration.gql'

import './styles.css'

const getFee = ({ amount, rate }) => {
  // return Math.ceil(amount / (1 - fee)) - amount
  return Math.ceil(rate * amount * 100) / 100
}

class RegistrationPayment extends Component {
  state = {
    // showGatewaysModal: false,
    omiseLoaded: false,
    showOmiseModal: false,
    showOmiseNetbankModal: false,
    showBankTransferModal: false,
    paymentLoading: false
  }

  componentWillMount () {
    // console.log(Omise)
    // console.log()
  }

  componentWillReceiveProps (nextProps) {
    const { data } = nextProps
    const event = _get(data, 'registration.event')
    const expired = _get(data, 'registration.expired')
    const status = _get(data, 'registration.status')
    const periods = _get(event, 'periods', [])
    // const preRegisterPeriod = _get(event, 'preRegisterPeriod')
    const currentPeriod = periods.find(period =>
      moment().isBetween(period.start, period.end) || moment().isBetween(period.preRegisterStart, period.preRegisterEnd)
    )
    // const registerPeriod = periods.find(p => !p.preRegister)
    const isPreRegister = currentPeriod && moment().isBetween(currentPeriod.preRegisterStart, currentPeriod.preRegisterEnd)
    // const preRegisterOpen = currentPeriod && currentPeriod.preRegister
    if (status !== 'submitted' || expired || isPreRegister) {
      const { slug } = event
      this.props.history.replace(`/events/${slug}`)
    }
  }

  // linePayUrl = ({ urlType }) => (
  //   `${config('baseUri')}/payment`
  // )
  handleOmiseLoaded = () => {
    this.setState({
      omiseLoaded: true
    })
  }

  // calculateAmount = registration => {
  //   let amount = 0
  //   registration.participants.forEach(participant => {
  //     participant.tickets.forEach(ticket => {
  //       discounted += ticket.ticketType.price
  //     })
  //   })
  //   return amount
  // }

  handleLinepaycheckout = async e => {
    e.preventDefault()
    this.setState({
      paymentLoading: true
    })
    const { registration } = this.props.data
    // this.props.form.validateFields((err, omiseData) => {
    //   if (!err) {
    try {
      const { data } = await this.props.payRegistration({
        variables: {
          record: {
            registrationId: registration._id,
            eventId: registration.eventId,
            method: 'linepay',
            data: {
              linepay: {
                completeRedirect: `${process.env
                  .REACT_APP_BASE_URI}/reg/${registration._id}`
                // confirmUrl: `${config('baseUri')}/linepayconfirm`,
                // cancelUrl: `${config('baseUri')}/linepaycancel`
              }
            }
          }
        }
      })
      const paymentUrl = _get(
        data,
        'payRegistration.record.data.linepay.paymentUrl.web'
      )
      if (paymentUrl) {
        window.location.href = paymentUrl
      }
    } catch (err) {
      const { graphQLErrors } = err
      if (graphQLErrors) {
        graphQLErrors.forEach(error => {
          message.error(this.props.intl.formatMessage({ id: `api.${error.message}` }))
        })
      } else {
        message.error(err.message)
      }
    } finally {
      this.setState({ paymentLoading: false })
    }
  }

  handleOmiseCheckout = async checkoutData => {
    this.setState({
      paymentLoading: true
    })
    const { registration } = this.props.data
    // eslint-disable-next-line no-undef
    Omise.setPublicKey(process.env.REACT_APP_OMISE_PUBLIC_KEY)
    const paymentMethod = _get(registration, 'event.settings.payment.methods', []).find(i => i.method === 'omise_card')
    const publicKey = _get(paymentMethod, 'publicKey')
    if (publicKey) {
      // eslint-disable-next-line no-undef
      Omise.setPublicKey(publicKey)
    }

    try {
      const card = await new Promise((resolve, reject) => {
        // eslint-disable-next-line no-undef
        Omise.createToken('card', checkoutData, (statusCode, response) => {
          if (statusCode !== 200) {
            return reject(response.message)
          }
          return resolve(response)
        })
      })
      const { data } = await this.props.payRegistration({
        variables: {
          record: {
            registrationId: registration._id,
            eventId: registration.eventId,
            method: 'omise_card',
            data: {
              omise: {
                bin: checkoutData.number.slice(0, 6),
                token: {
                  id: card.id
                }
              }
            }
          }
        }
      })
      const { registrationId } = _get(data, 'payRegistration.record')
      if (registrationId) {
        this.props.history.push(`/reg/${registrationId}`)
      }
    } catch (err) {
      const { graphQLErrors } = err
      if (graphQLErrors) {
        graphQLErrors.forEach(error => {
          message.error(this.props.intl.formatMessage({ id: `api.${error.message}` }))
        })
      } else {
        message.error(err.message)
      }
    } finally {
      this.setState({ paymentLoading: false })
    }
  }

  handleTransferCheckout = async checkoutData => {
    const { registration } = this.props.data
    this.setState({
      paymentLoading: true
    })
    try {
      const { data } = await this.props.payRegistration({
        variables: {
          record: {
            registrationId: registration._id,
            eventId: registration.eventId,
            method: 'transfer',
            data: {
              transfer: checkoutData
            }
          }
        }
      })
      const { registrationId } = _get(data, 'payRegistration.record')
      if (registrationId) {
        this.props.history.push(`/reg/${registrationId}`)
      }
    } catch (err) {
      const { graphQLErrors } = err
      if (graphQLErrors) {
        graphQLErrors.forEach(error => {
          message.error(this.props.intl.formatMessage({ id: `api.${error.message}` }))
        })
      } else {
        message.error(err.message)
      }
    } finally {
      this.setState({ paymentLoading: false })
    }
    // console.log(formData)
  }

  handleOmiseOffsiteCheckout = async ({ method, type, amount }) => {
    this.setState({
      paymentLoading: true
    })
    // Omise.setPublicKey(process.env.REACT_APP_OMISE_PUBLIC_KEY) // eslint-disable-line no-undef
    // console.log(omiseData, config('omisePublicKey'))
    const { registration } = this.props.data
    // eslint-disable-next-line no-undef
    Omise.setPublicKey(process.env.REACT_APP_OMISE_PUBLIC_KEY)
    const paymentMethod = _get(registration, 'event.settings.payment.methods', []).find(i => i.method === 'omise_card')
    const publicKey = _get(paymentMethod, 'publicKey')
    if (publicKey) {
      // eslint-disable-next-line no-undef
      Omise.setPublicKey(publicKey)
    }
    try {
      const source = await new Promise((resolve, reject) => {
        // eslint-disable-next-line no-undef
        Omise.createSource(type, { currency: 'thb', amount: amount * 100 }, (statusCode, response) => {
          if (statusCode !== 200) {
            return reject(response.message)
          }
          return resolve(response)
        })
      })
      const { data } = await this.props.payRegistration({
        variables: {
          record: {
            registrationId: registration._id,
            eventId: registration.eventId,
            method,
            data: {
              omise: {
                source: { id: source.id },
                returnUri: `${process.env
                  .REACT_APP_BASE_URI}/reg/${registration._id}`
              }
            }
          }
        }
      })
      window.location.href = _get(
        data,
        'payRegistration.record.data.omise.charge.authorize_uri'
      )
    } catch (err) {
      const { graphQLErrors } = err
      if (graphQLErrors) {
        graphQLErrors.forEach(error => {
          message.error(this.props.intl.formatMessage({ id: `api.${error.message}` }))
        })
      } else {
        message.error(err.message)
      }
    } finally {
      this.setState({ paymentLoading: false })
    }
  }

  handlePayatallCheckout = async checkoutData => {
    const { registration } = this.props.data
    this.setState({
      paymentLoading: true
    })
    this.props
      .payRegistration({
        variables: {
          record: {
            registrationId: registration._id,
            eventId: registration.eventId,
            method: 'payatall_cash',
            data: {
              payatall: {
                completeRedirect: `${process.env
                  .REACT_APP_BASE_URI}/reg/${registration._id}`
              }
            }
          }
        }
      })
      .then(({ data }) => {
        // const { _id } = _get(data, 'payRegistration.record')
        const payUrl = _get(data, 'payRegistration.record.data.payatall.payUrl')
        // window.location.href = `${process.env
        //   .REACT_APP_API_HOOKS_URI}/payments/payatall/${_id}/payslip`
        window.location.href = payUrl
      }).catch(err => {
        const { graphQLErrors } = err
        if (graphQLErrors) {
          graphQLErrors.forEach(error => {
            message.error(this.props.intl.formatMessage({ id: `api.${error.message}` }))
          })
        } else {
          message.error(err.message)
        }
        this.setState({ paymentLoading: false })
      })
  }

  handleOmiseModalClose = e => {
    this.setState({
      showOmiseModal: false
    })
  }

  handleOmiseModalClose = e => {
    this.setState({
      showOmiseModal: false
    })
  }

  handleBankTransferModalOpen = e => {
    this.setState({
      showBankTransferModal: true
    })
  }

  handleBankTransferModalClose = e => {
    this.setState({
      showBankTransferModal: false
    })
  }

  gatewayRate = gateway => {
    const { registration } = this.props.data
    const gatewayFees = _get(
      registration,
      'event.settings.payment.gatewayFees',
      []
    )
    const gwf = gatewayFees.find(gwf => gwf.gateway === gateway)
    return gwf ? gwf.fee : 0
  }

  getAmount = ({ gateway }) => {
    const { registration } = this.props.data
    const discounted = _get(registration, 'amount.discounted')
    const fee = getFee({ amount: discounted, rate: this.gatewayRate(gateway) })
    return {
      total: discounted + fee,
      discounted,
      fee
    }
  }

  render () {
    const { data, i18n: { locale }, intl } = this.props
    const { registration, loading } = data
    // const { search } = this.props.location
    // const { l: locale = 'th' } = queryString.parse(search)

    if (loading) {
      return <div>Loading...</div>
    } else if (!registration) {
      return <div>Registration Not found</div>
    }
    const { paymentQuotaExceeded } = registration

    const { status, amount } = registration
    const { discounted } = amount

    const customMessage = _get(
      registration,
      'event.settings.payment.customMessage'
    )

    const systemFee = _get(registration, 'event.settings.registration.fee', 0)

    const enabledMethods = _get(registration, 'event.settings.payment.methods', [])
      .filter(method => method.enabled).reduce((methods, item) => {
        methods[item.method] = true
        return methods
      }, {})

    // const linepayFee = gatewayRate('linepay')
    // const omiseFee = gatewayRate('omise')
    // const transferFee = gatewayRate('transfer')

    // const amount = registration ? this.calculateAmount(registration) : 0

    const paymentButtonStyle = {
      display: 'block',
      margin: '8px auto'
    }
    const paymentGroupStyle = {
      border: '1px dashed gainsboro',
      padding: '8px',
      marginBottom: '16px'
    }

    const bankAccountInfo = _get(
      registration,
      'event.settings.payment.bankAccountInfo'
    )

    return status && status === 'paid'
      ? <Redirect to={`/reg/${registration._id}`} />
      : <div>
        <Form onSubmit={this.handlePreviewRegistration} style={{ padding: '26px' }} className="EventRegisterPage">
          <div className="eventDetails" style={{ paddingTop: '85px', display: 'flex', justifyContent: ' center' }}>
            <div className="eventTitle">
              {_get(data, ['registration', 'event', 'name', locale])}
            </div>
          </div>
          <div style={{ maxWidth: '1000px', margin: 'auto' }}>
            <RegistrationSteps step="pay" />
            <div style={{ padding: '26px', background: 'white', borderRadius: '0 0 8px 8px' }}>
              {paymentQuotaExceeded
                ? <div style={{ textAlign: 'center' }}><FormattedMessage id="api.QUOTA_EXCEEDED" /></div>
                : <div>
                  <Script
                    url="https://cdn.omise.co/omise.js.gz"
                    onLoad={this.handleOmiseLoaded}
                    onError={() => console.error('error loading omise')}
                  />
                  <h2 style={{ textAlign: 'center', margin: '8px' }}><FormattedMessage id="app.selectPaymentMethod" defaultMessage="Select payment method"/></h2>
                  {customMessage &&
                <blockquote style={{ textAlign: 'center' }}>
                  {customMessage[locale]}
                </blockquote>
                  }
                  {this.state.omiseLoaded &&
                <Row type="flex" justify="center" gutter={16} style={{ textAlign: 'center' }}>
                  {enabledMethods['omise_card'] && <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }}>
                    <div style={paymentGroupStyle}>
                      <div style={{ fontWeight: 'bold' }}><FormattedMessage id="paymentMethod.card"/></div>
                      <div>
                        {systemFee
                          ? <React.Fragment>
                            <FormattedMessage id="app.entryFeeBaht" defaultMessage="Entry Fee {amount} Baht" tagName="div" values={{
                              amount: intl.formatNumber(this.getAmount({ gateway: 'omise' }).discounted - systemFee)
                            }}/>
                            <FormattedMessage id="app.processingFeeBaht" defaultMessage="Processing Fee {amount} Baht" tagName="div" values={{
                              amount: intl.formatNumber(systemFee)
                            }}/>
                          </React.Fragment>
                          : <FormattedMessage id="app.entryFeeBaht" defaultMessage="Entry Fee {amount} Baht" tagName="div" values={{
                            amount: intl.formatNumber(this.getAmount({ gateway: 'omise' }).discounted)
                          }} />
                        }
                        <FormattedMessage id="app.paymentProcessingFeeBaht" defaultMessage="Processing Fee" values={{
                          amount: intl.formatNumber(this.getAmount({ gateway: 'omise' }).fee)
                        }}/>
                      </div>
                      <Button
                        icon="credit-card"
                        type="primary"
                        onClick={() => this.setState({ showOmiseModal: true })}
                        style={paymentButtonStyle}
                      >
                        <FormattedMessage id="app.payBaht" values={{
                          amount: intl.formatNumber(this.getAmount({ gateway: 'omise' }).total)
                        }}/>
                      </Button>
                    </div>
                  </Col>}
                  {enabledMethods['linepay'] && <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }}>
                    <div style={paymentGroupStyle}>
                      <div style={{ fontWeight: 'bold' }}><FormattedMessage id="paymentMethod.linepay"/></div>
                      <div>
                        {systemFee
                          ? <React.Fragment>
                            <FormattedMessage id="app.entryFeeBaht" defaultMessage="Entry Fee {amount} Baht" tagName="div" values={{
                              amount: intl.formatNumber(this.getAmount({ gateway: 'linepay' }).discounted - systemFee)
                            }}/>
                            <FormattedMessage id="app.processingFeeBaht" defaultMessage="Processing Fee {amount} Baht" tagName="div" values={{
                              amount: intl.formatNumber(systemFee)
                            }}/>
                          </React.Fragment>
                          : <FormattedMessage id="app.entryFeeBaht" defaultMessage="Entry Fee {amount} Baht" tagName="div" values={{
                            amount: intl.formatNumber(this.getAmount({ gateway: 'linepay' }).discounted)
                          }} />
                        }
                        <FormattedMessage id="app.paymentProcessingFeeBaht" defaultMessage="Processing Fee" values={{
                          amount: intl.formatNumber(this.getAmount({ gateway: 'linepay' }).fee)
                        }}/>
                      </div>
                      <Button
                        type="primary"
                        onClick={this.handleLinepaycheckout}
                        loading={this.state.paymentLoading}
                        style={paymentButtonStyle}
                      >
                        <FormattedMessage id="app.payBaht" values={{
                          amount: intl.formatNumber(this.getAmount({ gateway: 'linepay' }).total)
                        }}/>
                      </Button>
                    </div>
                  </Col>}
                  {enabledMethods['transfer'] && <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }}>
                    <div style={paymentGroupStyle}>
                      <div style={{ fontWeight: 'bold' }}><FormattedMessage id="paymentMethod.transfer"/></div>
                      <div>
                        {systemFee
                          ? <React.Fragment>
                            <FormattedMessage id="app.entryFeeBaht" defaultMessage="Entry Fee {amount} Baht" tagName="div" values={{
                              amount: intl.formatNumber(this.getAmount({ gateway: 'transfer' }).discounted - systemFee)
                            }}/>
                            <FormattedMessage id="app.processingFeeBaht" defaultMessage="Processing Fee {amount} Baht" tagName="div" values={{
                              amount: intl.formatNumber(systemFee)
                            }}/>
                          </React.Fragment>
                          : <FormattedMessage id="app.entryFeeBaht" defaultMessage="Entry Fee {amount} Baht" tagName="div" values={{
                            amount: intl.formatNumber(this.getAmount({ gateway: 'transfer' }).discounted)
                          }} />
                        }
                        <FormattedMessage id="app.paymentProcessingFeeBaht" defaultMessage="Processing Fee" values={{
                          amount: intl.formatNumber(this.getAmount({ gateway: 'transfer' }).fee)
                        }}/>
                      </div>
                      <Button
                        type="primary"
                        onClick={this.handleBankTransferModalOpen}
                        style={paymentButtonStyle}
                      >
                        <FormattedMessage id="app.payBaht" values={{
                          amount: intl.formatNumber(this.getAmount({ gateway: 'transfer' }).total)
                        }}/>
                      </Button>
                    </div>
                  </Col>}
                  {enabledMethods['omise_netbank'] && <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }}>
                    <div style={paymentGroupStyle}>
                      <div style={{ fontWeight: 'bold' }}><FormattedMessage id="paymentMethod.internetBanking"/></div>
                      {systemFee
                        ? <React.Fragment>
                          <FormattedMessage id="app.entryFeeBaht" defaultMessage="Entry Fee {amount} Baht" tagName="div" values={{
                            amount: intl.formatNumber(this.getAmount({ gateway: 'omise' }).discounted - systemFee)
                          }}/>
                          <FormattedMessage id="app.processingFeeBaht" defaultMessage="Processing Fee {amount} Baht" tagName="div" values={{
                            amount: intl.formatNumber(systemFee)
                          }}/>
                        </React.Fragment>
                        : <FormattedMessage id="app.entryFeeBaht" defaultMessage="Entry Fee {amount} Baht" tagName="div" values={{
                          amount: intl.formatNumber(this.getAmount({ gateway: 'omise' }).discounted)
                        }} />
                      }
                      <FormattedMessage id="app.paymentProcessingFeeBaht" defaultMessage="Processing Fee" tagName="div" values={{
                        amount: intl.formatNumber(this.getAmount({ gateway: 'omise' }).fee)
                      }}/>
                      <FormattedMessage id="app.bankProcessingFeeBaht" defaultMessage="Bank Processing Fee" tagName="div" values={{
                        amount: intl.formatNumber(10)
                      }}/>
                      <FormattedMessage id="app.payBaht" tagName="div" values={{
                        amount: intl.formatNumber(this.getAmount({ gateway: 'omise' }).total + 10)
                      }}/>
                      <Button
                        type="primary"
                        onClick={e =>
                          this.handleOmiseOffsiteCheckout({
                            type: 'internet_banking_bay',
                            method: 'omise_netbank',
                            amount: this.getAmount({ gateway: 'omise' }).total
                          })}
                        loading={this.state.paymentLoading}
                        style={paymentButtonStyle}
                      >
                        KrugsriOnline
                      </Button>
                      <Button
                        type="primary"
                        onClick={e =>
                          this.handleOmiseOffsiteCheckout({
                            type: 'internet_banking_bbl',
                            method: 'omise_netbank',
                            amount: this.getAmount({ gateway: 'omise' }).total
                          })}
                        loading={this.state.paymentLoading}
                        style={paymentButtonStyle}
                      >
                        Bualuang iBanking
                      </Button>
                      <Button
                        type="primary"
                        onClick={e =>
                          this.handleOmiseOffsiteCheckout({
                            type: 'internet_banking_ktb',
                            method: 'omise_netbank',
                            amount: this.getAmount({ gateway: 'omise' }).total
                          })}
                        loading={this.state.paymentLoading}
                        style={paymentButtonStyle}
                      >
                        KTB Netbank
                      </Button>
                      <Button
                        type="primary"
                        onClick={e =>
                          this.handleOmiseOffsiteCheckout({
                            type: 'internet_banking_scb',
                            method: 'omise_netbank',
                            amount: this.getAmount({ gateway: 'omise' }).total
                          })}
                        loading={this.state.paymentLoading}
                        style={paymentButtonStyle}
                      >
                        SCBEasy
                      </Button>
                    </div>
                  </Col>}
                  {enabledMethods['payatall_cash'] && <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }}>
                    <div style={paymentGroupStyle}>
                      <div>Counter Service</div>
                      {systemFee
                        ? <React.Fragment>
                          <FormattedMessage id="app.entryFeeBaht" defaultMessage="Entry Fee {amount} Baht" tagName="div" values={{
                            amount: intl.formatNumber(this.getAmount({ gateway: 'payatall_cash' }).discounted - systemFee)
                          }}/>
                          <FormattedMessage id="app.processingFeeBaht" defaultMessage="Processing Fee {amount} Baht" tagName="div" values={{
                            amount: intl.formatNumber(systemFee)
                          }}/>
                        </React.Fragment>
                        : <FormattedMessage id="app.entryFeeBaht" defaultMessage="Entry Fee {amount} Baht" tagName="div" values={{
                          amount: intl.formatNumber(this.getAmount({ gateway: 'payatall_cash' }).discounted)
                        }} />
                      }
                      <FormattedMessage id="app.payBaht" tagName="div" values={{
                        amount: intl.formatNumber(this.getAmount({ gateway: 'payatall_cash' }).total)
                      }}/>
                      <Button
                        onClick={e => this.handlePayatallCheckout()}
                        loading={this.state.paymentLoading}
                        style={paymentButtonStyle}
                      >
                        Counter Service (
                        {discounted})
                      </Button>
                    </div>
                  </Col>}
                  {enabledMethods['omise_alipay'] && <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }}>
                    <div style={paymentGroupStyle}>
                      <div style={{ fontWeight: 'bold' }}><FormattedMessage id="paymentMethod.alipay"/></div>
                      <div>
                        {systemFee
                          ? <React.Fragment>
                            <FormattedMessage id="app.entryFeeBaht" defaultMessage="Entry Fee {amount} Baht" tagName="div" values={{
                              amount: intl.formatNumber(this.getAmount({ gateway: 'omise' }).discounted - systemFee)
                            }}/>
                            <FormattedMessage id="app.processingFeeBaht" defaultMessage="Processing Fee {amount} Baht" tagName="div" values={{
                              amount: intl.formatNumber(systemFee)
                            }}/>
                          </React.Fragment>
                          : <FormattedMessage id="app.entryFeeBaht" defaultMessage="Entry Fee {amount} Baht" tagName="div" values={{
                            amount: intl.formatNumber(this.getAmount({ gateway: 'omise' }).discounted)
                          }} />
                        }
                        <FormattedMessage id="app.paymentProcessingFeeBaht" defaultMessage="Processing Fee" values={{
                          amount: intl.formatNumber(this.getAmount({ gateway: 'omise' }).fee)
                        }}/>
                      </div>
                      <Button
                        icon="alipay"
                        type="primary"
                        onClick={e =>
                          this.handleOmiseOffsiteCheckout({
                            method: 'omise_alipay',
                            type: 'alipay',
                            amount: this.getAmount({ gateway: 'omise' }).total }
                          )}
                        style={paymentButtonStyle}
                      >
                        <FormattedMessage id="app.payBaht" values={{
                          amount: intl.formatNumber(this.getAmount({ gateway: 'omise' }).total)
                        }}/>
                      </Button>
                    </div>
                  </Col>}
                </Row>}
                  <OmiseModal
                    amount={this.getAmount({ gateway: 'omise' }).total}
                    visible={this.state.showOmiseModal}
                    loading={this.state.paymentLoading}
                    onCheckout={this.handleOmiseCheckout}
                    onClose={this.handleOmiseModalClose}
                    locale={locale}
                  />
                  <TransferModal
                    bankAccountInfo={bankAccountInfo}
                    amount={this.getAmount({ gateway: 'transfer' }).total}
                    visible={this.state.showBankTransferModal}
                    loading={this.state.paymentLoading}
                    onCheckout={this.handleTransferCheckout}
                    onClose={this.handleBankTransferModalClose}
                    locale={locale}
                  />
                </div>
              }
            </div>
          </div>
        </Form>
      </div>
  }
}

// const registrationQuery = gql`
//   query registration($id: MongoID!) {
//     registration(_id: $id) {
//       _id
//       code
//       status
//       userId
//       eventId
//       createdAt
//       updatedAt
//       expireAt
//       expired
//       amount {
//         total
//         discount
//         discounted
//       }
//       participants {
//         _id
//         userId
//         eventId
//         registrationId
//         tickets {
//           ticketType {
//             _id
//             eventId
//             raceId
//             periodId
//             group
//             price
//             kind
//           }
//           productTypeId
//           _id
//           eventId
//           participantId
//           #        orderId
//           kind
//         }
//       }
//       event {
//         _id
//         slug
//         code
//         logoUrl
//         coverUrl
//         description {
//           en
//           th
//         }
//         startDate
//         endDate
//         published
//         regClosed
//         website
//         location
//         organizerId
//         reserved
//         registered
//         settings {
//           payment {
//             bankAccountInfo
//             gatewayFees {
//               _id
//               gateway
//               fee
//             }
//           }
//         }
//         name {
//           en
//           th
//         }
//       }
//     }
//   }
// `

const payRegistrationMutation = gql`
  mutation payRegistration($record: CreateOnePaymentInput!) {
    payRegistration(record: $record) {
      recordId
      record {
        _id
        registrationId
        registration {
          _id
          status
        }
        data
      }
    }
  }
`

export default compose(
  Form.create(),
  injectIntl,
  inject('i18n'),
  observer,
  graphql(registrationQuery, {
    options: ({ match: { params: { id } } }) => ({
      variables: { _id: id }
    })
  }),
  graphql(payRegistrationMutation, {
    name: 'payRegistration'
  })
)(RegistrationPayment)

// TODO: transfor props get rid of data



// WEBPACK FOOTER //
// ./src/App/pages/EventRegistration/RegistrationPayment/RegistrationPayment.js